import { postForm } from '@/shared/api/client';
import { getListRows } from '@/shared/lib/pagination';
import { toOptions } from '@/shared/lib/options';
import type { PlaceItem } from '@/shared/api/places';
import type { ListResponse } from '@/shared/ui/list/types';

const DEFAULT_TYPE_ID = 1;

export async function fetchCarTypeOptions() {
  const res = await postForm<ListResponse>('/car/type/list/', {});
  return toOptions(getListRows<PlaceItem>(res, ['types']));
}

/** Marks of a car type (cars when no type is chosen), all pages — legacy `getMarks(token, typeId)`. */
export async function fetchCarMarkOptions(typeId: string) {
  const res = await postForm<ListResponse>('/car/mark/list/', {
    type_id: typeId || DEFAULT_TYPE_ID,
    page: 0,
  });
  return toOptions(getListRows<PlaceItem>(res, ['marks']));
}

/** Models of a mark, all pages — legacy `getModels(token, markId)`. */
export async function fetchCarModelOptions(markId: string) {
  const res = await postForm<ListResponse>('/car/model/list/', { mark_id: markId, page: 0 });
  return toOptions(getListRows<PlaceItem>(res, ['models']));
}

/** Generations of a model — legacy `getAllGenerationsByModel`. */
export async function fetchCarGenerationOptions(modelId: string) {
  const res = await postForm<ListResponse>('/car/generation/get-all-by-model/', { model_id: modelId });
  return toOptions(getListRows<PlaceItem>(res, ['models']));
}

/** Modifications of a generation — legacy `getAllModificationByGeneration`. */
export async function fetchCarModificationOptions(generationId: string) {
  const res = await postForm<ListResponse>('/car/modification/get-all-by-generation/', {
    generation_id: generationId,
  });
  return toOptions(getListRows<PlaceItem>(res, ['models']));
}
